import React from 'react';
import { ThemeProvider } from './src/context/ThemeContext';
import { CookieConsentProvider } from './src/context/CookieConsentContext';

export const wrapRootElement = ({ element }) => {
  return (
    <ThemeProvider>
      <CookieConsentProvider>{element}</CookieConsentProvider>
    </ThemeProvider>
  );
};